(function($) {

	// Content product - change image on color variation hover
	function init_variations(){

		$(".content-product__color").off("mouseenter mouseleave" ); // unbind previsously binded events

		$(".content-product__color").hover(function(){

			var id_product = $(this).data('id-product')
			if(!id_product){
				return;
			}

			var $product_item = $(this).closest('.content-product')

			// Change view to variation
			$product_item.removeClass('product-view').addClass('variation-view')

			// Add stock status
			var variation_stock_status = $(this).data('stock-status')
			if(variation_stock_status){
				$product_item.addClass('variation-'+variation_stock_status)
			}

			// Add if variation can be wished
			var variation_can_be_wished = $(this).data('can-be-wished')
			if(variation_can_be_wished){
				$product_item.addClass('variation-can-be-wished')
			}

			// Change image
			var $variation_image = $product_item.find('.content-product__images_variations_img[data-id-product="'+id_product+'"]')
			if($variation_image.length > 0){
				// Show variation product image
				$product_item.find('.content-product__images_img').hide()
				$variation_image.show()
			}

		}, function(){

			var $product_item = $(this).closest('.content-product')

			// Change view back to product
			$product_item.removeClass('variation-view').addClass('product-view')

			// Remove variation classes (all starting with "variation-")
			$product_item.removeClass(function (index, className) {
				return (className.match (/(^|\s)variation-\S+/g) || []).join(' ');
			});

			// Change image back
			$('.content-product__images_variations_img').hide()
			$product_item.find('.content-product__images_img').show()

		})

		// Filtration FE
		$( ".filtration__range-input" ).focusout(function() {
			$(this).find(".filtration__range-label").css("opacity", "1");
		})
		$( ".filtration__range-input" ).focusin(function() {
			$(this).find(".filtration__range-label").css("opacity", "0");
		})
	}

	//allow only numbers in text input
	function forceNumeric(){
		var $input = $(this);
		$input.val($input.val().replace(/[^\d]+/g,''));
	}
	$('.filtration__range').on('propertychange input', 'input[type="text"]', forceNumeric);



	//toggle filtration on responsive
	$(".filtration-close").on("click", function () {
		$("#filtration").addClass("--hidden");
		$("body").css("overflow-y", "auto");
	})
	$(".filtration-open").on("click", function () {
		$("#filtration").removeClass("--hidden");
		$("body").css("overflow-y", "hidden");
	})

	//change value of inputs when slide or click
	var $myslider = $("#price-slider").bootstrapSlider();

	$myslider.on("change", function() {

		var value = $myslider.bootstrapSlider('getValue')
		for (var i = 0; i < value.length; ++i) {
			var $input = $("input.sliderValue[data-index=" + i + "]");
			$input.val(value[i]);
			$input.parent().find(".filtration__range-label").text(value[i] + " " + $input.data("currency"));
		}

	});

	// change value of range when change
	$("input.sliderValue").change(function() {
		var $this = $(this);
		var $val = $this.val() + " " + $this.data("currency");
		$this.parent().find(".filtration__range-label").text($val);
		$myslider.bootstrapSlider('setValue', [parseInt($(".sliderValue[data-index='0']").val()), parseInt($(".sliderValue[data-index='1']").val())]);

		//Set min and max number
		var max = parseInt($(this).attr('max'));
		var min = parseInt($(this).attr('min'));
		if ($(this).val() > max)
		{
			$(this).val(max);
			$(this).parent().find(".filtration__range-label").text(max);
		}
		else if ($(this).val() < min)
		{
			$(this).val(min);
			$(this).parent().find(".filtration__range-label").text(min);
		}

	});



	// Active filters
	var filters = {}

	// Elements
	var $form = $('#archive-product-filtration')
	var $reset_filters = $('.filtration__button-remove')
	var $ordering_option = $('.orderby_option')
	var baseUrl = $form.attr('action')

	// Prevent filters spam
	var timeout
	var loading_next_page = false

	function load_filters(){
		var form_data = $form.serializeArray()

		filters = {}
		form_data.forEach(function (item){
			// Set price_from & price_to only if less/greater than min (default) value
			if(item.name == 'price_from') {
				if(item.value > parseInt($("input[name='price_from']").attr('min'))){
					filters[item.name] = item.value
				}
			}else if(item.name == 'price_to'){
				if(item.value < parseInt($("input[name='price_to']").attr('max'))){
					filters[item.name] = item.value
				}
			}else if(filters[item.name]){
				// Set 2nd and next value
				filters[item.name] += ","+item.value
			}else{
				// Set 1st value
				filters[item.name] = item.value
			}
		})
	}

	$form.change(function(){

		// Set timeout - let others scripts like price range slider run first
		setTimeout(() => {

			clearTimeout(timeout)
			remove_products()
			show_loading()
			set_active_labels()

			load_filters()

			$('#load-more-products-button').hide();

			$('.archive-product__infinite_loading').hide();

			// Wait 0,5sec - prevent request spam caused by fast clicks etc. in filters
			timeout = setTimeout(() => {
				load_products(get_new_url(), false)
			}, 500)

		}, 0)

	})

	$reset_filters.click(reset_filters)

	$ordering_option.click(function(e){
		e.preventDefault()
		$('.orderby_option.active').removeClass('active')
		$(this).addClass('active')
		$form.trigger('change')
	})

	function init_load_more_button(){
		$('#load-more-products-button').click(function(e){
			e.preventDefault()
			$(this).hide()
			$('.archive-product__infinite_loading').show()
			$('.archive-product__pagination').hide()
			load_products($(this).attr("href"), true)
		})
	}

	function remove_products(){
		$("#products-grid").empty()
	}

	function show_loading(){
		$("#products-loading").show()
		$(".archive-product__pagination").html('&nbsp;')
		$(".archive-product__result-count").html('&nbsp;')
		$('#load-more-products-button').hide();
	}

	function hide_loading(){
		$("#products-loading").hide()
	}

	function reset_filters(e){

		e.preventDefault()

		// Reset checkboxes
		$("input[type='checkbox']").prop("checked", false)

		// Reset price
		$myslider.bootstrapSlider('refresh');
		$myslider.trigger('change')
		$form.trigger('change')
	}

	function get_new_url(base = false){
		var url = base ? base : baseUrl;
		let first = true;

		// Add filters if set
		if(filters){
			for (const [key, value] of Object.entries(filters)) {
				if(first){
					first = false
					url += "?"
				}else{
					url += "&"
				}

				url += key + "=" + value
			}
		}

		// Ordering
		var active_filter = $('.orderby_option.active').data('order-by')
		if(active_filter && active_filter !== 'relevance' && active_filter !== 'menu_order'){
			if(first){
				first = false
				url += "?"
			}else{
				url += "&"
			}

			url += "order_by=" + active_filter
		}
		return url;
	}

	function update_url(url){
		let obj = { Url: url };
		window.history.replaceState(obj,"", url);
		return url
	}

	function parseQuery() {
		var queryString = window.location.search
		var query = {};
		var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
		for (var i = 0; i < pairs.length; i++) {
			var pair = pairs[i].split('=');
			query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
		}
		return query;
	}

	function set_active_filters(){
		var query = parseQuery()

		if(query){
			for (const [key, values] of Object.entries(query)) {

				var vals = values.split(',')
				vals.forEach(function(value){

					// Checkboxes
					var checkbox = $("input[type='checkbox'][name='"+key+"'][value='"+value+"']")
					checkbox.prop("checked", true)

				})

			}
		}

	}

	function set_active_labels(){

		var $labels_container = $("#archive-active-filters")
		$labels_container.empty()

		// Add price range slider labels
		var range_price = $myslider.bootstrapSlider('getValue')

			var price_from = range_price[0],
				price_min = $myslider.data('slider-min'),
				price_to = range_price[1],
				price_max = $myslider.data('slider-max'),
				currency = $myslider.data('currency'),
                from_text = $myslider.data('from-text'),
                to_text = $myslider.data('to-text');

		    // From
			if(price_from != price_min){
				var price_from_label = $("<div class='gp-filter-label col-auto'><span class='archive-product__filter_label'>" + from_text + price_from + " " + currency +"</span></div>").appendTo($labels_container)
				// Bind click to remove
				price_from_label.click(function(){
					$myslider.bootstrapSlider('setValue', [price_min, price_to]);
					$myslider.trigger('change')
					$form.trigger('change')
				})
			}

		    // To
			if(price_to != price_max){
				var price_to_label = $("<div class='gp-filter-label col-auto'><span class='archive-product__filter_label'>"+ to_text + price_to + " " + currency +"</span></div>").appendTo($labels_container)
				// Bind click to remove
				price_to_label.click(function(){
					$myslider.bootstrapSlider('setValue', [price_from, price_max]);
					$myslider.trigger('change')
					$form.trigger('change')
				})
			}


		// Add selected checkboxes filter labels
		var $active_filters = $("#archive-product-filtration input[type='checkbox']:checked")
		$active_filters.each(function(){
			var new_label = $("<div class='gp-filter-label col-auto'><span class='archive-product__filter_label'>"+$(this).data('label')+"</span></div>").appendTo($labels_container)
			new_label.data('checkbox', $(this))
			// Bind click to remove
			new_label.click(function(){
				$(this).data('checkbox').prop("checked", false)
				$form.trigger('change')
			})
		})
	}

	var request;

	function load_products( url, append){

		// add wc-ajax to target url
		var target = url + (url.includes('?') ? '&' : '?') + 'gp-ajax=product_archive';

		// Abort previous request if is loading
		if(typeof request !== "undefined"){
			request.abort()
		}

		request = gp_ajax({
			url: target,
			type: "post",
			dataType: 'json',
			data: {append: append},
		})



		// success
		request.done(function (response, textStatus, jqXHR){

			// Change url
			update_url(url);

			// Bind javascript on new added products
			init_variations()
			init_load_more_button()

			$(document).trigger("ajax_products_loaded")

		});

		request.always(function (){
			loading_next_page = false
			hide_loading()
		})

	}

	// On DOM ready
	init_variations()
	init_load_more_button()
	set_active_filters()
	set_active_labels()
	load_filters()

})(jQuery);
